
	  <div class="fileimage" [ngStyle]="{'display': (!frontpageExist && !showIconIfUnavailable) ? 'none' : 'block'}"
		   [style.width]="width" [style.height]="height">
		  <img *ngIf="frontpageExist" class="frontpage" [src]="frontpageImage" alt="Front page image">
		  <img *ngIf="!frontpageExist && showIconIfUnavailable" class="doctypeimage"
		   src="{{doctypeImage}}" alt="File type image"
		   (error)="handleDoctypeImageNotFound()">
	  </div>
  